
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topic/[[...topic]]",
      function () {
        return require("private-next-pages/topic/[[...topic]].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/topic/[[...topic]]"])
      });
    }
  